import {
	Formats,
	RichTranslationValues,
	TranslationValues,
	useTranslations,
} from "next-intl";
import { ReactNode } from "react";

type NestedKeyOf<ObjectType> = ObjectType extends object
	? {
			[Key in keyof ObjectType]:
				| `${Key & string}`
				| `${Key & string}.${NestedKeyOf<ObjectType[Key]>}`;
		}[keyof ObjectType]
	: never;

export const generateTranslationHook = <T>(segment: string) => {
	interface TranslationHookFunction {
		(
			key: NestedKeyOf<T>,
			values?: TranslationValues | undefined,
			formats?: Partial<Formats> | undefined
		): string;
		raw: (key: NestedKeyOf<T>) => any;
		rich: (
			key: NestedKeyOf<T>,
			values?: RichTranslationValues | undefined,
			formats?: Partial<Formats> | undefined
		) => ReactNode;
	}

	return (): TranslationHookFunction => useTranslations(segment);
};
